(() => {
  const desktop = window.matchMedia('(min-width: 901px)');
  const setExpanded = (button, open) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  };
  const closeCollections = () => document.querySelectorAll('[data-collection-toggle]').forEach(button => setExpanded(button, false));
  const initialize = root => {
    root.querySelectorAll('[data-collection-toggle], .menu-toggle').forEach(button => { button.hidden = false; });
    root.querySelectorAll('[data-collection-navigation]').forEach(group => {
      if (group.dataset.initialized) return;
      group.dataset.initialized = 'true';
      const button = group.querySelector('[data-collection-toggle]');
      group.addEventListener('pointerenter', event => {
        if (desktop.matches && event.pointerType === 'mouse') setExpanded(button, true);
      });
      group.addEventListener('pointerleave', () => {
        if (!group.contains(document.activeElement)) setExpanded(button, false);
      });
      group.addEventListener('focusout', event => {
        if (!group.contains(event.relatedTarget)) setExpanded(button, false);
      });
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-collection-toggle], .menu-toggle');
    if (button) {
      setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
    } else {
      if (!event.target.closest('[data-collection-navigation]')) closeCollections();
      if (event.target.closest('#MobileMenu a')) {
        const toggle = document.querySelector('.menu-toggle');
        if (toggle) setExpanded(toggle, false);
      }
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const open = document.querySelector('[data-collection-toggle][aria-expanded="true"], .menu-toggle[aria-expanded="true"]');
      if (open) { setExpanded(open, false); open.focus(); event.preventDefault(); }
    }
    if (event.key === 'ArrowDown' && event.target.matches('[data-collection-toggle]')) {
      setExpanded(event.target, true);
      document.getElementById(event.target.getAttribute('aria-controls')).querySelector('a')?.focus();
      event.preventDefault();
    }
  });
  desktop.addEventListener('change', () => {
    closeCollections();
    const toggle = document.querySelector('.menu-toggle');
    if (toggle) setExpanded(toggle, false);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
